import {
  LayoutDashboard,
  Users,
  Stethoscope,
  ClipboardList,
  Activity,
  Pill,
  History,
  BarChart3,
  Package,
  ShieldCheck,
  Lock,
  Settings,
  DollarSign,
  FileText,
  FlaskConical,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  key: string;
  label: string;
  to: string;
  icon: LucideIcon;
  badge?: number;
  /** Si está definido, sólo los usuarios con uno de estos roles ven el item. */
  roles?: ReadonlyArray<string>;
}

export interface NavSection {
  title: string;
  items: ReadonlyArray<NavItem>;
}

export const NAV_SECTIONS: ReadonlyArray<NavSection> = [
  {
    title: 'Principal',
    items: [
      { key: 'dashboard', label: 'Dashboard', to: '/dashboard', icon: LayoutDashboard },
    ],
  },
  {
    title: 'Operación clínica',
    items: [
      { key: 'pacientes', label: 'Pacientes', to: '/pacientes', icon: Users },
      {
        key: 'procedimientos',
        label: 'Procedimientos',
        to: '/procedimientos',
        icon: Stethoscope,
      },
    ],
  },
  {
    title: 'Documentos clínicos',
    items: [
      {
        key: 'consentimiento',
        label: 'Consentimiento',
        to: '/consentimiento',
        icon: ClipboardList,
      },
      {
        key: 'anestesia',
        label: 'Registro de anestesia',
        to: '/anestesia',
        icon: Activity,
      },
      { key: 'gasto', label: 'Hoja de gasto', to: '/gasto', icon: Pill },
      {
        key: 'patologia',
        label: 'Resultado de patología',
        to: '/patologia',
        icon: FlaskConical,
      },
    ],
  },
  {
    title: 'Gestión',
    items: [
      { key: 'historial', label: 'Consulta histórica', to: '/historial', icon: History },
      { key: 'reportes', label: 'Reportes', to: '/reportes', icon: BarChart3 },
      { key: 'payroll', label: 'Payroll enfermería', to: '/payroll', icon: DollarSign },
    ],
  },
  {
    // Solo el súper administrador (rol `admin`) ve esta sección completa.
    title: 'Sistema',
    items: [
      {
        key: 'usuarios',
        label: 'Usuarios y roles',
        to: '/usuarios',
        icon: ShieldCheck,
        roles: ['admin'],
      },
      {
        key: 'roles',
        label: 'Perfiles y permisos',
        to: '/roles',
        icon: Lock,
        roles: ['admin'],
      },
      {
        key: 'consentimientos',
        label: 'Consentimientos',
        to: '/admin/consentimientos',
        icon: FileText,
        roles: ['admin'],
      },
      { key: 'catalogo', label: 'Catálogo', to: '/catalogo', icon: Package, roles: ['admin'] },
      { key: 'auditoria', label: 'Auditoría', to: '/auditoria', icon: Lock, roles: ['admin'] },
      {
        key: 'configuracion',
        label: 'Configuración',
        to: '/configuracion',
        icon: Settings,
        roles: ['admin'],
      },
    ],
  },
];
